function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import Select, { optionPropType } from '../Select';
import FormControlLabel from '../FormControlLabel';
export var FormControlSelect = /*#__PURE__*/memo(function FormControlSelect(props) {
  var label = props.label,
      labelPlacement = props.labelPlacement,
      leftAdornment = props.leftAdornment,
      width = props.width,
      _onChange = props.onChange,
      onBlur = props.onBlur,
      rest = _objectWithoutProperties(props, ["label", "labelPlacement", "leftAdornment", "width", "onChange", "onBlur"]);

  return /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Select, Object.assign({
      style: {
        width: width
      },
      onChange: function onChange(e) {
        if (_onChange) _onChange(e);
        if (onBlur) onBlur(e);
      }
    }, omit(rest, 'renderFormControl'))),
    label: label,
    labelPlacement: labelPlacement,
    leftAdornment: leftAdornment,
    error: rest.error,
    gutterBottom: true
  });
});
export var propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(optionPropType),
  value: optionPropType
};
FormControlSelect.propTypes = propTypes;
FormControlSelect.displayName = 'FormControlSelect';
export default FormControlSelect;